import React, { useRef } from "react";

interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  min?: string;
  max?: string;
  step?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  placeholder,
  type = "text",
  required = false,
  maxLength,
  disabled,
  min,
  max,
  step,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const borderColor = error
    ? "border-red-500"
    : value.trim()
    ? "border-green-500"
    : "border-stroke dark:border-form-strokedark";

  // Handle date field click to open native date picker
  const handleWrapperClick = () => {
    if (type === "date" && inputRef.current && !inputRef.current.disabled) {
      inputRef.current.showPicker?.();
      inputRef.current.focus();
    }
  };

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {/* Wrapper div to open date picker when clicked */}
      <div
        className={`w-full rounded-lg border py-2 px-4 transition duration-300 focus-within:ring-1 cursor-pointer dark:bg-form-input dark:text-white ${borderColor}`}
        onClick={handleWrapperClick}
      >
        <input
          ref={inputRef}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder || `Enter ${label.toLowerCase()}`}
          className="w-full bg-transparent outline-none"
          maxLength={maxLength}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
        />
      </div>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default FormField;
